import gsap from 'gsap';

import ScrollAnime from './anime/_scroll';


export default class Main{
    
    constructor(){
        this._init();
    }


    _init(){
        this.scroll = new ScrollAnime();
    }
}